import { labelsApi } from "api/TenantSlug/Label/api";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";
import { LabelType } from "types/enums";

import LabelData = App.Data.LabelData;

export type LabelTypeFilter = LabelType | "all";

interface UseLabelSelectOptionsParams {
    type?: LabelTypeFilter;
    useNameAsValue?: boolean;
}

export const useLabelSelectOptions = ({ type = "all", useNameAsValue = false }: UseLabelSelectOptionsParams = {}) => {
    const queryParams = type === "all"
        ? {}
        : {
            filter: {
                filter: {
                    type: type,
                },
            },
        };

    return useSelectOptions<LabelData>({
        apiFunction: (payload) => labelsApi.index(payload),
        dataKey: "labels",
        cacheKey: `label-select-${type}-${useNameAsValue ? "name" : "id"}`,
        queryParams,
        mapToOption: (label) => ({
            label: label.name,
            value: useNameAsValue ? label.name : label.id,
        }),
    });
};
